import type { ReactNode } from "react";
import { useSessionQuery } from "#/src/hooks/useSession";
import {
  ParentReferralClaimContext,
  useClaimOwner,
  useResumeParentReferralClaim,
} from "#/src/pages/referrals/useParentReferralClaim";

function ResumeParentReferralClaim() {
  useResumeParentReferralClaim();
  return null;
}

function UserClaimProvider({ userId, children }: { userId?: string; children: ReactNode }) {
  const owner = useClaimOwner(userId);
  return (
    <ParentReferralClaimContext.Provider value={owner}>
      <ResumeParentReferralClaim />
      {children}
    </ParentReferralClaimContext.Provider>
  );
}

export function ParentReferralClaimProvider({ children }: { children: ReactNode }) {
  const { sessionData } = useSessionQuery();
  const userId = sessionData?.roles.includes("parent") ? sessionData.user_details.uid : undefined;
  return <UserClaimProvider userId={userId}>{children}</UserClaimProvider>;
}

export default ParentReferralClaimProvider;
